import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReAuth } from './base-query'
import type { PatchUserBody, User } from './types/user'

export const usersApi = createApi({
	reducerPath: 'usersApi',
	baseQuery: baseQueryWithReAuth,
	tagTypes: ['User'],
	endpoints: (builder) => ({
		getMe: builder.query<User, void>({
			query: () => '/users/@me',
			providesTags: ['User'],
		}),

		updateUser: builder.mutation<User, PatchUserBody>({
			query: (body) => ({ url: '/users/@me', method: 'PATCH', body }),
			invalidatesTags: ['User'],
		}),
	}),
})

export const { useGetMeQuery, useUpdateUserMutation } = usersApi
